import { DOCUMENT_COMPONENT_TYPES } from "../../../constants/document";
import DeleteBaseCommand from "./deleteBaseCommand";

class DeleteDocComponentCommand extends DeleteBaseCommand {
  constructor(componentData) {
    super(componentData);
    this.componentData = componentData;
  }

  execute() {
    super.execute();
  }

  undo() {
    super.undo();
    const { section } = this.componentData;
    if (section.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER) {
      this.componentData.addDealTableTab();
    }
  }
}

export default DeleteDocComponentCommand;
